import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserAddOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 24h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2"
    />
    <path
      fill="currentColor"
      d="M16 2a7 7 0 0 0-7 7v1.5a9.7 9.7 0 0 0 2.9 6.7c-5.7.6-9.9 3.4-9.9 6.7V28a2 2 0 0 0 2 2h14a1 1 0 0 0 0-2H4v-4c0-2.4 4.4-5 10.7-5a19.4 19.4 0 0 1 6 1 1 1 0 1 0 .6-2l-1.7-.4a9.8 9.8 0 0 0 3.4-7V9a7 7 0 0 0-7-7m5 8.5a7.8 7.8 0 0 1-1.6 4.5 4.5 4.5 0 0 1-3.4 2c-2.7 0-5-3.6-5-6.5V9.1A5 5 0 0 1 16 4a5 5 0 0 1 5 5z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconUserAddOutlineSVG);
ForwardRef.displayName = "IconUserAddOutline";
export { ForwardRef as IconUserAddOutline };
